import { render } from "./UpdateLog.vue?vue&type=template&id=1b6b88ee&scoped=true"
import script from "./UpdateLog.vue?vue&type=script&lang=js"
export * from "./UpdateLog.vue?vue&type=script&lang=js"

import "./UpdateLog.vue?vue&type=style&index=0&id=1b6b88ee&scoped=true&lang=css"

import exportComponent from "/home/ali/PhpstormProjects/insta-catalog-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6b88ee"]])

export default __exports__